import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import Spinner from '../../icons/spinner';
import { cleanWhite, daveGrey } from '../../colors';
import DefaultTHeme from './theme';
/*::
import type { Node } from 'react';
import type { PrimaryButtonThemeType } from './theme';

type Props = {|
  type?: 'button' | 'reset' | 'submit',
  children?: Node,
  disabled?: boolean,
  loading?: boolean,
  onClick?: any,
  href?: string,
  target?: '__blank' | '__self' | '__parent' | '__top',
  linkComponent?: Node,
  theme?: PrimaryButtonThemeType,
  rest?: any,
|}
*/

var Primary = function Primary(_ref
/*: Props */
) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'submit' : _ref$type,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Submit' : _ref$children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      href = _ref.href,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? 'a' : _ref$linkComponent,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return undefined;
  } : _ref$onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTHeme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "children", "disabled", "loading", "href", "linkComponent", "onClick", "theme"]);

  var renderButton = function renderButton(as
  /*: string | Node */
  ) {
    return /*#__PURE__*/React.createElement(theme.Button, Object.assign({
      as: as,
      href: href,
      to: href,
      type: href ? null : type,
      onClick: disabled || loading ? function (e) {
        return e.preventDefault();
      } : function (e) {
        return onClick(e);
      },
      disabled: disabled ? 1 : 0,
      loading: loading ? 1 : 0
    }, rest), /*#__PURE__*/React.createElement(theme.Hover, {
      disabled: disabled ? 1 : 0,
      loading: loading ? 1 : 0,
      "data-test": "button-hover"
    }, children, loading && !disabled ? /*#__PURE__*/React.createElement(theme.SpinnerWrapper, {
      "data-test": "button-spinner-wrapper"
    }, /*#__PURE__*/React.createElement(Spinner, {
      color: cleanWhite(),
      sliceColor: daveGrey(),
      height: 2,
      "data-test": "button-spinner"
    })) : null));
  };

  if (href) {
    return renderButton(linkComponent);
  }

  return renderButton('button');
};

export default Primary;